module.exports = __webpack_public_path__ + "img/frozen_bg.63f8e8eb.png";